import React from 'react'
import { FindCandidate } from '../Pages/FindCandidate/FindCandidate'

function Findcandidate() {
  return (
    <>
        <FindCandidate />
    </>
  )
}

export default Findcandidate
